import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import Routes from 'Routes';
import LogoPlaceholder from 'assets/company-logo-placeholder.svg';

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #17181E;
  background-color: #FFF;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledImg = styled.img`
  flex: 0 0 auto;
  max-height: 62px;
  max-width: 62px;
`;

const InfoContainer = styled.div`
  margin-left: 16px;
  flex: 0 1 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
`;

const NameContainer = styled.div`
  flex: 1 0 auto;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 22px;
  color: #17181E;
  margin-bottom: 10px;

  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const DescriptionContainer = styled.div`
  flex: 1 0 auto;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 13px;
  color: #999999;

  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const ExhibitorSearchResultItem = ({
  id,
  name,
  logo,
  tags,
}) => (
  <StyledLink to={Routes.booth(id)}>
    <StyledImg src={logo} />
    <InfoContainer>
      <NameContainer>
        { name }
      </NameContainer>
      <DescriptionContainer>
        { tags.join(', ') }
      </DescriptionContainer>
    </InfoContainer>
  </StyledLink>
);

ExhibitorSearchResultItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  logo: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
};

ExhibitorSearchResultItem.defaultProps = {
  logo: LogoPlaceholder,
  tags: [],
};

export default ExhibitorSearchResultItem;
